// @ts-nocheck
import { Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

const GenericToolTip = ({ title, char, style = {}, ...rest }) => (
  <>
    {title?.length > char - 1 ? (
      <Tooltip
        title={<Typography style={{ fontSize: '12px' }}>{title}</Typography>}
        placement="top"
        style={{ fontSize: '12px', zIndex: '9999999' }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        <span
          style={{
            ...style,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title?.length > char
            ? title.substring(0, char).concat('...')
            : title}
        </span>
      </Tooltip>
    ) : (
      <span style={{ ...style }}>{title}</span>
    )}
  </>
);

GenericToolTip.propTypes = {
  title: PropTypes.string,
  char: PropTypes.number,
  style: PropTypes.object,
};
GenericToolTip.defaultProps = {
  title: '',
  char: 40,
  style: {},
};

export default GenericToolTip;
